import { TextField, MenuItem } from "@mui/material"
import { useState, useEffect } from "react"
import API from "../../services/API/CRM";

export default function AdminSelect({value, onChange, label, required, disabled, sx}){

    const [users, setUsers] = useState([]);

    useEffect(() => {

        API.getAdmins()
            .then(r => setUsers(Array.isArray(r.data) ? r.data : []))
            .catch(e => console.log(e))

    }, [value])


    return <TextField
        label={label || 'Administrateurs'}
        select
        size='small'
        value={value?.id || ''}
        onChange={e => onChange( users.find(u => u.id === e.target.value) )}
        required={required ? true : false}
        disabled={disabled}
        sx={sx || {}}
    >
        {users
            .sort((a,b) => a.name > b.name ? 1 : -1)
            .map(u => 
                <MenuItem key={u.id} value={u.id}>{u.name}</MenuItem>    
            )
        }
    </TextField>
}